module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    attrs: {
      "id": "Step1"
    }
  }, [(_vm.product.producttype == 'adoption') ? _c('div', {
    staticClass: "wwf-checkbox"
  }, [_c('label', [_vm._v("\n      Make this a gift for someone\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.isGift),
      expression: "donation.isGift"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isGift-step-1",
      "name": "isGift"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.isGift) ? _vm._i(_vm.donation.isGift, null) > -1 : (_vm.donation.isGift)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.isGift,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.isGift = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.isGift = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "isGift", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  })])]) : _vm._e(), _vm._v(" "), (_vm.packages.length > 1 && _vm.product.producttype != 'wildcard') ? _c('h2', [_vm._v(_vm._s(_vm.donation.isGift ? 'Select your adoption pack to gift to someone' : 'Select your pack'))]) : _vm._e(), _vm._v(" "), (_vm.packages.length > 1 && _vm.product.producttype != 'wildcard') ? _c('div', {
    staticClass: "wwf-radio-bttns"
  }, [_vm._l((_vm.packages), function(item, index) {
    return _c('label', {
      attrs: {
        "for": 'package-' + item.code
      }
    }, [_vm._v("\n      " + _vm._s(item.display) + "\n      "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.donation.packagecode),
        expression: "donation.packagecode"
      }],
      attrs: {
        "type": "radio",
        "name": "package",
        "id": 'package-' + item.code
      },
      domProps: {
        "value": item.code,
        "checked": index == 0 ? 'checked' : '',
        "checked": _vm._q(_vm.donation.packagecode, item.code)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.donation, "packagecode", item.code)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('package')) ? _c('p', [_vm._v("Please choose your pack")]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), (_vm.packages.length > 0 && _vm.product.producttype != 'wildcard') ? _c('div', {
    staticClass: "wwf-packs"
  }, [_c('div', {
    staticClass: "packs"
  }, [(_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null && _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack != null) ? _c('div', {
    staticClass: "pack",
    style: ('background-image:url(' + _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack.image + ')')
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "toy",
    class: _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null && _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy != null ? 'has-toy' : 'has-no-toy',
    style: (_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null && _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy != null ? 'background-image:url(' + _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy.image + ')' : '')
  })]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('p', [(_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null && _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack != null) ? _c('span', [_vm._v(_vm._s(_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).pack.text))]) : _vm._e(), _vm._v(" "), (_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }) != null && _vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy != null) ? _c('span', [_vm._v(_vm._s(_vm.packages.find(function (x) { return x.code == _vm.donation.packagecode; }).toy.text))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.product.packages && _vm.product.packages.length > 1 && _vm.product.producttype == 'wildcard') ? _c('h2', [_vm._v("Choose your design")]) : _vm._e(), _vm._v(" "), (_vm.product.packages && _vm.product.packages.length > 1 && _vm.product.producttype == 'wildcard') ? _c('div', {
    staticClass: "wwf-packs wildcard--select"
  }, [_vm._l((_vm.product.packages), function(item, index) {
    return _c('label', {
      attrs: {
        "for": 'package-' + item.code
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.donation.packagecode),
        expression: "donation.packagecode"
      }],
      attrs: {
        "type": "radio",
        "name": "package",
        "id": 'package-' + item.code
      },
      domProps: {
        "value": item.code,
        "checked": index == 0 ? 'checked' : '',
        "checked": _vm._q(_vm.donation.packagecode, item.code)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.donation, "packagecode", item.code)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "tooltipstered",
      staticStyle: {
        "margin-bottom": "15px"
      },
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('package')) ? _c('p', [_vm._v("Please choose your design")]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wwf-radio-bttns donation-type-tabs",
    class: {
      'single-tabs': _vm.product.donationtypes.length === 1
    }
  }, [_vm._l((_vm.product.donationtypes), function(donationtype, index) {
    return _c('label', {
      staticClass: "donation-type-tab",
      attrs: {
        "for": 'selection-' + donationtype
      }
    }, [_vm._v("\n      " + _vm._s((donationtype == "Regular") ? 'Give monthly' : 'Give once') + "\n      "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDonationType),
        expression: "selectedDonationType"
      }],
      attrs: {
        "type": "radio",
        "name": "selectedDonationType",
        "id": 'selection-' + donationtype
      },
      domProps: {
        "value": donationtype,
        "checked": index == 0 ? 'checked' : '',
        "checked": _vm._q(_vm.selectedDonationType, donationtype)
      },
      on: {
        "change": function($event) {
          _vm.selectedDonationType = donationtype
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }), _vm._v(" "), _vm._m(0, false, false)], 2), _vm._v(" "), _vm._l((_vm.product.donationtypes), function(donationtype) {
    return (_vm.donation.type == donationtype) ? _c('div', {
      staticClass: "dollar-handles"
    }, [_vm._l((_vm.product.dollarhandles[donationtype]), function(index) {
      return _c('label', {
        attrs: {
          "for": 'handle-' + donationtype + '-' + index.amount
        }
      }, [_c('input', {
        directives: [{
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }, {
          name: "model",
          rawName: "v-model",
          value: (_vm.donation.dollarhandle),
          expression: "donation.dollarhandle"
        }],
        attrs: {
          "type": "radio",
          "name": 'handle-' + donationtype,
          "id": 'handle-' + donationtype + '-' + index.amount,
          "data-vv-as": "amount"
        },
        domProps: {
          "value": index.amount,
          "checked": _vm._q(_vm.donation.dollarhandle, index.amount)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.donation, "dollarhandle", index.amount)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "amount",
        class: {
          'has-cents': !(index.amount.indexOf('.00') >= 0)
        }
      }, [_c('span', [_vm._v("$" + _vm._s((index.amount.indexOf('.00') >= 0) ? index.amount.slice(0, -3) : index.amount))])]), _vm._v(" "), _c('span', {
        staticClass: "handle"
      }), _vm._v(" "), _c('span', {
        staticClass: "svg-circle"
      }, [_c('svg', {
        staticStyle: {
          "width": "100%",
          "height": "100%"
        }
      }, [_c('circle', {
        attrs: {
          "cx": "50%",
          "cy": "50%",
          "r": "40%",
          "stroke-width": "3"
        }
      })])])])
    }), _vm._v(" "), (!(_vm.product.extrasetting && _vm.product.extrasetting.hidecustomhandle)) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.donation.dollarhandle),
        expression: "donation.dollarhandle"
      }],
      attrs: {
        "type": "radio",
        "name": 'handle-' + donationtype,
        "value": "custom",
        "id": 'handle-custom-' + donationtype
      },
      domProps: {
        "checked": _vm._q(_vm.donation.dollarhandle, "custom")
      },
      on: {
        "click": function($event) {
          _vm.setFocus()
        },
        "change": function($event) {
          _vm.$set(_vm.donation, "dollarhandle", "custom")
        }
      }
    }), _vm._v(" "), _vm._m(1, true, false), _vm._v(" "), _c('span', {
      staticClass: "handle"
    }), _vm._v(" "), _c('span', {
      staticClass: "svg-circle"
    }, [_c('svg', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "50%",
        "cy": "50%",
        "r": "40%",
        "stroke-width": "3"
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.donation.dollarhandle == 'custom'),
        expression: "donation.dollarhandle=='custom'"
      }],
      staticClass: "field other-amount-form",
      class: _vm.donation.amount ? 'has-content' : ''
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true,
          donationAmountIsValid: true,
          regex: /^\d+(\.\d{1,2})?$/
        }),
        expression: "{required: true, donationAmountIsValid: true, regex: /^\\d+(\\.\\d{1,2})?$/}"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.donation.amount),
        expression: "donation.amount"
      }],
      ref: "customhandle",
      refInFor: true,
      class: {
        'border-red': _vm.errors.has('custom-handle')
      },
      attrs: {
        "type": "tel",
        "name": "custom-handle",
        "id": "custom-handle",
        "placeholder": "Choose an amount",
        "data-vv-as": "amount"
      },
      domProps: {
        "value": (_vm.donation.amount)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.donation, "amount", $event.target.value)
        }, function($event) {
          _vm.checkMaxAmount()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "custom-handle"
      }
    }, [_vm._v("Choose an amount")]), _vm._v(" "), _c('span', {
      staticClass: "wwf-alert"
    }, [(_vm.errors.firstByRule('custom-handle', 'donationAmountIsValid')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('custom-handle')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.maxAmount),
        expression: "maxAmount"
      }],
      staticClass: "message-big-amount"
    }, [_c('p', [_vm._v("\n        For donations above $75,000 please contact our Impact Partnerships team, so we can be sure your gift benefits the area of conservation you are most passionate about. \n      ")]), _vm._v(" "), _vm._m(2, true, false)]), _vm._v(" "), (_vm.donation.dollarhandle != null && _vm.donation.dollarhandle != 'custom' && _vm.donation.dollarhandle != '') ? _c('div', {
      staticClass: "dollar-handles-desc",
      class: {
        'has-amount': (_vm.donation.dollarhandle != null), 'addToolPos-': false
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.product.dollarhandles[donationtype].find(function (x) { return x.amount == _vm.donation.dollarhandle; }) ? _vm.product.dollarhandles[donationtype].find(function (x) { return x.amount == _vm.donation.dollarhandle; }).text : ""))])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "wwf-alert"
    }, [(_vm.errors.first('handle-' + donationtype)) ? _c('p', [_vm._v("Please choose your donation amount")]) : _vm._e()]), _vm._v(" "), (_vm.donation.amount && _vm.product.extrasetting && _vm.product.extrasetting.displaytaxcalculator) ? _c('tax-calculator', {
      attrs: {
        "amount": _vm.donation.amount
      }
    }) : _vm._e()], 2) : _vm._e()
  }), _vm._v(" "), _c('h2', [_vm._v("Enter your email")]), _vm._v(" "), _c('div', {
    staticClass: "field",
    class: _vm.donation.email ? 'has-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.email),
      expression: "donation.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        donationCheckEmail: true
      }),
      expression: "{ required: true, donationCheckEmail: true }"
    }],
    class: {
      'border-red': _vm.errors.has('email') || _vm.errors.has('donationCheckEmail')
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "Email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.donation.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2940/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email " + _vm._s(_vm.errors.firstByRule('email', 'required') ? 'required' : ''))]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('email', 'donationCheckEmail')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_vm._v("\n      Send me emails about important conservation news and how I can help WWF protect the diversity of life on Earth.\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.optin),
      expression: "donation.optin"
    }],
    attrs: {
      "type": "checkbox",
      "id": "opt-in-step-1",
      "name": "opt-in"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.optin) ? _vm._i(_vm.donation.optin, null) > -1 : (_vm.donation.optin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.optin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.optin = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.optin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "optin", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  })])])], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "wwf-tooltip"
  }, [_c('p', [_vm._v("Donations of $2 or more are tax deductible. For adoptions, the toy value cannot be claimed as a tax deductible gift.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "amount"
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Please email  "), _c('a', {
    attrs: {
      "href": "mailto:partnerships@wwf.org.au",
      "target": "_blank"
    }
  }, [_vm._v("partnerships@wwf.org.au")]), _vm._v(". Thank you so much for your kindness!\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-faa290c0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=os8u77dxteg!./~/string-replace-webpack-plugin/loader.js?id=zkc3fbyssup!./src/components/product/Step1.vue
// module id = 698
// module chunks = 0